import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'supply-by-domain-component',
  templateUrl: './supply-by-domain.component.html',
  styleUrls: ['./supply-by-domain.component.scss']
})

export class SupplyByDomainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
